export const ThinkPairShareGrow = {
  title: 'Think. Pair. Share. Grow.',
  icon: '/static/templates_icons/ThinkPairShareGrow.svg',
  prompt: `
    <p class="pink-selectable">
      [Learn more about how to implement this activity in your classroom at
      <a target="_blank" href="https://parlayideas.com/templates/#think-pair-share-grow">https://parlayideas.com/templates/#think-pair-share-grow</a>]
    </p>
    <h3>Part 1 - Think</h3>
    <p>
      First, review the following content:

      <span class="pink-selectable">[Insert content (articles, videos, images etc) for your students to review independently or as a class.]</span>
    </p>
    <h3>Part 2 - Pair & Share</h3>
    <p>
      Pair up with the person to your left to discuss.
      Pick one of the two of you to answer the following questions in their Written RoundTable submission:
    </p>
    <p class="pink-selectable">
      <strong>1. [Insert Question 1 here]</strong> <br>
      <strong>2. [Insert Question 2 here]</strong>
    </p>
    <p>
      Don’t forget to include the name (or secret identity) of your partner at the top of your submission.
    </p>
    <h3>Part 3 - Grow</h3>
    <p>
      Whoever did not respond can skip the submission step by pressing the “Skip Submission”
      button instead of writing a response.
    </p>
    <p>
      Once you have joined the discussion, pick at least <span class="pink-selectable">two</span> of your peers' submissions and
      independently comment using the guided feedback questions provided. Try your best to
      comment on submissions that don’t yet have any feedback.
    </p>
  `,
};


// WEBPACK FOOTER //
// ./src/app/components/modals/New_RoundTable/EditorMCE/Templates/Defaults/ThinkPairShareGrow.js